import { Fragment, memo } from 'react';

import { CommentRow, InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';

import ActivityDetailContainer from '../ActivityDetailContainer';

const WhatsappGeneralDetail = memo(({ activity, getIsCommentCollapsed, labels, shared }) => {
    const { companyContent, finalContactContent, opportunityRow, rightContent, titleRow } = shared;

    const mainContent = activity.Description && (
        <Fragment>
            <InfoRowSection />
            <CommentRow
                text={activity.Description}
                noTabs={false}
                getIsCommentCollapsed={getIsCommentCollapsed}
            />
        </Fragment>
    );

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: mainContent,
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={labels.account}
                                value={companyContent}
                                rightContent={rightContent}
                            />
                            <InfoRow label={labels.contact} value={finalContactContent} />
                            <InfoRow label={labels.role} value={activity.ContactRole} />
                            {opportunityRow}
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

WhatsappGeneralDetail.displayName = 'WhatsappGeneralDetail';

export default WhatsappGeneralDetail;
